export default {
    methods: {
        $_studentService_handle(student) {
            this.newBooking(student);
            this.myScheduleBooking(student);
            this.calendarBooking(student);
            this.rescheduleBooking(student);
            this.selfServeBooking(student);
        },
        calendarBooking(student) {
            if (!this.bookingSource.isCalendar) return;
            this.$_data_studentPurchaseOptions(student).filter((option) => {
                return option.access.includes(this.form.type);
            });
        },
        newBooking(student) {
            if (!this.bookingSource.isNew) return;
        },
        rescheduleBooking(student) {
            if (!this.bookingSource.isReschedule) return;
        },
        selfServeBooking(student) {
            if (!this.bookingSource.isSelfServe) return;
        },
        myScheduleBooking(student) {
            if (!this.bookingSource.isMySchedule) return;
        },
    },
};
